/**
 * Order-related TypeScript types
 * SHARED between frontend and backend
 * ABSOLUTE RULE: NO 'any' types allowed
 */

import { Timestamp } from 'firebase/firestore';

export enum ServiceType {
  DAY_TO_DUSK = 'DAY_TO_DUSK',
  ITEM_REMOVAL = 'ITEM_REMOVAL',
  STAGING = 'STAGING',
  DESCRIPTION = 'DESCRIPTION',
  DESTAGING = 'DESTAGING',
  COLLAGE = 'COLLAGE',
  WATERMARK = 'WATERMARK',
  ENHANCEMENT = 'ENHANCEMENT',
}

export enum OrderStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum DescriptionFormat {
  CAPTION = 'CAPTION',
  DESCRIPTION = 'DESCRIPTION',
  MLS_REMARKS = 'MLS_REMARKS',
}

export enum EnhancementMode {
  DUSK = 'DUSK',
  GENERAL = 'GENERAL',
  VIBRANT = 'VIBRANT',
  BRIGHT = 'BRIGHT',
}

export interface OrderAttempt {
  attemptNumber: number;
  timestamp: Timestamp;
  status: OrderStatus;
  resultUrl: string | null;
  errorMessage: string | null;
}

export interface OrderDocument {
  orderId: string;
  userId: string;
  serviceType: ServiceType;
  status: OrderStatus;
  creditsCost: number;
  createdAt: Timestamp;
  updatedAt: Timestamp;

  // For image services
  inputImageUrl?: string;
  inputImagePath?: string;
  inputImageUrls?: string[];
  maskImageUrl?: string;
  stagingStyle?: string;
  removalPrompt?: string;
  enhancementMode?: EnhancementMode;

  // For description service
  descriptionFormat?: DescriptionFormat;
  propertyDetails?: string;

  // Retry system
  attempts: OrderAttempt[];
  maxAttempts: number;

  // Results
  currentResultUrl: string | null;
  currentResultPath: string | null;
}

export interface CreateOrderRequest {
  serviceType: ServiceType;
  inputImageUrl?: string;
  inputImageUrls?: string[];
  maskImageUrl?: string;
  stagingStyle?: string;
  removalPrompt?: string;
  enhancementMode?: EnhancementMode;
  descriptionFormat?: DescriptionFormat;
  propertyDetails?: string;
}

export interface RetryOrderRequest {
  orderId: string;
}
